import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon, Select } from "antd";
import axios from "axios";
import "./Pages.css";
import OrdemProducaoForm from '../components/OrdemProducaoForm';
import OrdemProducaoPedidosForm from '../components/OrdemProducaoPedidosForm';
import FiltrosForm from '../components/FiltrosForm';
import JustificativaForm from '../components/JustificativaForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, getTipoUsuario, getEmpresa } from "../utils/LoginManager";
import InputForm from "../components/InputForm";
import Colors from "../utils/Colors";


const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;


export default class extends Component {
  state = {
    listaRegistros: [],
    registro: '',
    eventStatus: '',
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdeTotal: 0,
    qtdePend: 0,
    qtdeFin: 0,

    formVisivel: false,
    modalPedidosVisible: false,

    formFiltroVisivel: false,
    formJustfVisivel: false,
    justificativa: '',

    filtros: {
      tipoTela: 'OP',
      buscaOrdem: { campo: 'op_dt_venda', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    this.buscaStatus();
    const usuario = getUsuario();
    getEmpresa().then(codEmpresa => {
      getTipoUsuario().then(tipoUsuario => {
        this.state.filtros.buscaUsuario = {
          key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
        }
        this.setState({
          usuario,
          codEmpresa,
          tipoUsuario,
        }, this.getListaRegistros);
      })
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, qtdeTotal: 0, qtdePend: 0, qtdeFin: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaMunicipio,
      buscaOrdem } = this.state.filtros;

    let op_dt_venda_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      op_dt_venda_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let op_dt_venda_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      op_dt_venda_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/producao', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          codCliente: buscaPessoa.key,
          cidade: buscaMunicipio.key,
          op_dt_venda_ini,
          op_dt_venda_fim,
          print: 0,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.consulta;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          qtdeTotal: response.data.qtdeTotal,
          qtdePend: response.data.qtdePend,
          qtdeFin: response.data.qtdeFin,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.op_idf) {
      request = axios.put(`/producao/update/${registro.op_idf}`, registro);
    } else {
      request = axios.post(`/producao/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Produção gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          op_idf: 0,
          op_numero: '',
          op_dt_emissao: moment().format('DD/MM/YYYY'),
          op_dt_entrega: moment().format('DD/MM/YYYY'),
          op_pessoa: { key: '0' },
          op_prioridade: 1,
          op_obs: '',
          listaProdutos: [],
          visualizando: false,
        }
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/producao/show/${registro.op_idf}`)
      .then(response => {
        const { data } = response;
        data.dados.op_pessoa = {
          key: String(data.dados.op_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.op_dt_emissao = moment(data.dados.op_dt_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir a Produção Nº ${registro.op_numero} do cliente ${registro.pes_nome} ?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/producao/delete/${registro.op_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.op_idf === registro.op_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };




  onFecharModalPedidosClick = () => {
    this.setState({
      modalPedidosVisible: false,
    }, this.getListaRegistros);
  }

  onNovoPedidos = (event) => {
    this.setState({
      modalPedidosVisible: true,
      registroSelecionadoPedido: {
        selectedRowKeys: [],
        tipoTela: 'OP',
        visualizando: true,
      },
    });
  }



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({
      [id]: value
    });
  };

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }


  renderDataHora = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }







  buscaStatus = (value) => {
    this.setState({ statusSelect: [] })
    axios.get('/statusVenda/lista', {
    }).then(response => {
      const { data } = response;
      const statusSelect = data.map(regList => {
        return {
          key: regList.sv_idf,
          label: regList.sv_descricao,
        }
      });
      this.setState({
        statusSelect,
      })
    }).catch(error => {
      console.error(error.response);
    })
  }

  renderStatus = (sit, registro) => {
    const op_situacao = {
      key: sit,
      label: registro.sv_descricao,
    }
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
        <InputForm
          type="select"
          id="op_situacao"
          ref="op_situacao"
          value={op_situacao}
          placeholder="Status da Venda"
          onChange={situacao => this.onVerificaStatus(registro, situacao)}
          data={this.state.statusSelect}
          validator={value => Boolean(value)}
          style={{ width: 150 }}
          disabled={registro.sv_descricao === 'ORÇAMENTO' ? true : false}
        />
      </Col>
    );
  };

  onVerificaStatus = (registro, event) => {
    if ((event.target.value.label === 'REVISAR') || (event.target.value.label === 'BLOQUEADA')) {
      this.onAbrirJustifClick(registro, event);
    } else {
      this.onChangeStatus(registro, event, '')
    }
  }

  onChangeStatus = (registro, event, justificativa) => {
    justificativa = justificativa ? justificativa : 'X';
    this.setState({ carregando: true })
    axios.
      put(`/producao/mudaSituacao/${registro.op_idf}/${event.target.value.key}/${justificativa}`)
      .then(response => {
        registro.op_situacao = event.target.value.key;
        registro.vj_data = moment().format('DD/MM/YYYY');
        registro.vj_justf_bloq = event.target.value.key;
        this.setState({
          listaRegistros: this.state.listaRegistros.concat([]),
          justificativa: '',
          registro: '',
          eventStatus: '',
          carregando: false
        }, () => {
          if (justificativa) {
            this.getListaRegistros();
          }
        })
      }).catch(error => {
        console.error(error.response);
        this.setState({ carregando: false })
      })
  };

  onAbrirJustifClick = (registro, eventStatus) => {
    this.setState({
      formJustfVisivel: true,
      registro,
      eventStatus,
      justificativa: '',
    })
  };

  onJustifClick = (justificativa) => {
    this.setState({
      formJustfVisivel: false,
      justificativa,
    }, this.onChangeStatus(this.state.registro, this.state.eventStatus, justificativa.justificativa))
  };

  onCancelarJustifClick = () => {
    this.setState({
      formJustfVisivel: false,
      justificativa: '',
      registro: '',
      eventStatus: '',
    })
  };







  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">

        {getTemPermissao('OrdemProducaoPage', 'editar') ? (
          <Tooltip title={registro.op_dt_entrega ? "Visualizar" : "Editar"}>
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon={registro.op_dt_entrega ? "eye" : "edit"} />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('OrdemProducaoPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={registro.op_dt_entrega ? true : false} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={true} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        )}

      </ButtonGroup>
    );
  };


  renderCliente = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome}</span>
    );
  };

  renderCidade = (cmun_descricao, registro) => {
    return (
      <span>{cmun_descricao} - {registro.cuf_sigla}</span>
    );
  };

  renderOrigem = (origem, registro) => {
    return (
      <span>{registro.pi_idf_venda ? 'Pedido' : 'Manual'}</span>
    );
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };







  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado, registroSelecionadoPedido, filtros, justificativa,
      total, pagina, limite, formFiltroVisivel, formJustfVisivel, modalPedidosVisible } = this.state;

    // console.log('OrdemProducaoPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Ordens de Produção</h2>
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 70 }}>
          <Row>
            <Col xs={8} style={{ marginTop: -5 }}>
              {(!this.state.tipoUsuario) || (getTemPermissao('OrdemProducaoPage', 'novo')) ? (
                <span>
                  <Tooltip title="Nova Ordem de Produção Avulsa">
                    <Button
                      onClick={this.onAdicionarClick}
                      className="pageFiltro-adicionar"
                    >
                      Adicionar
                    </Button>
                  </Tooltip>

                  <Tooltip title="Nova Ordem de Produção de Pedidos">
                    <Button
                      onClick={this.onNovoPedidos}
                      className="pageFiltro-adicionar"
                    >
                      Pedidos
                    </Button>
                  </Tooltip>
                </span>
              ) : null}

              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

              <JustificativaForm
                visivel={formJustfVisivel}
                onJustifClick={this.onJustifClick}
                onCancelarJustifClick={this.onCancelarJustifClick}
                justificativa={justificativa}
              />

            </Col>


            <Col xs={24} sm={16} style={{ marginTop: -15 }}>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Total</span></Row>
                <Row><span>{this.state.qtdeTotal}</span></Row>
              </Col>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Pendente</span></Row>
                <Row><span>{this.state.qtdePend}</span></Row>
              </Col>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Finalizado</span></Row>
                <Row><span>{this.state.qtdeFin}</span></Row>
              </Col>
            </Col>

          </Row>

          <OrdemProducaoForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <OrdemProducaoPedidosForm
            visivel={modalPedidosVisible}
            onSalvarPedidosClick={this.onSalvarPedidosClick}
            onFecharModalPedidosClick={this.onFecharModalPedidosClick}
            registroSelecionadoPedido={registroSelecionadoPedido}
            tipoTela='OP'
          />

        </div>



        <div style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.op_idf)}
          >
            <Column
              key="op_numero"
              dataIndex="op_numero"
              title={this.renderTitulo("Núm")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="op_dt_emissao"
              dataIndex="op_dt_emissao"
              title={this.renderTitulo("Data Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderDataHora}
              width={"13%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="dataEntrega"
              dataIndex="dataEntrega"
              title={this.renderTitulo("Data Entrega")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"13%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="op_prioridade"
              dataIndex="op_prioridade"
              title={this.renderTitulo("Prioridade")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderCliente}
              width={"20%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="cmun_descricao"
              dataIndex="cmun_descricao"
              title={this.renderTitulo("Cidade")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderCidade}
              width={"15%"}
              align="left"
              className="listaCadastro"
            />
            {/* <Column
              key="."
              dataIndex="."
              title={this.renderTitulo("Status")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderSituacao}
              width={"10%"}
              align="center"
              className="listaCadastro"
            /> */}
            <Column
              key="pi_idf_venda"
              dataIndex="pi_idf_venda"
              title={this.renderTitulo("Origem")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderOrigem}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>Ações</div>}
              render={this.renderAcoes}
              width={"20%"}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/OrdemProducaoPage.js